import React from 'react'
import c from 'classnames'
import { connect } from 'react-redux'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import isEqual from 'lodash/isEqual'

import { money, moneyShort, TP_PARTNER_ID } from 'utils'
import tpLogo from 'static/images/tpLogo.png'
import { updateQuote } from 'actions/quoteActions'
import { getQuoteValue } from 'selectors/quoteSelectors'
import { getRooftopWebsite, getRooftopName } from 'selectors/appStatusSelectors'

const TP = window.SNAP

export class TradePendingReport extends React.Component {
  state = { loading: false }

  getTradePendingReport(tpVehicle) {
    let {
        mileage,
        updateQuote,
        tradeIndex,
        zipCode,
        cantDo,
        vehicleId,
        quoteId,
        rooftopWebsite,
      } = this.props,
      options = {
        mileage: `${mileage || 0}`,
      },
      tpArgs = [
        TP_PARTNER_ID,
        rooftopWebsite,
        tpVehicle,
        zipCode,
        {
          ...options,
          type: 'detailed',
          include_retail: true,
        },
      ]

    if (cantDo) return

    this.setState({ loading: true })

    TP &&
      tpVehicle.id &&
      TP.get_report(...tpArgs, (err, report = {}) => {
        let report_url = TP.get_report_url(...tpArgs, {
          ...options,
          type: 'detailed',
          include_retail: true,
        })

        this.setState({ loading: false })

        !err &&
          updateQuote(vehicleId, quoteId, {
            [`trades[${tradeIndex}].tradePending.report`]: {
              ...report.report,
              report_url,
            },
          })
      })
  }

  componentDidUpdate(oldProps) {
    let newTriggers = get(this.props, 'triggers'),
      oldTriggers = get(oldProps, 'triggers')

    if (!isEqual(newTriggers, oldTriggers) && newTriggers.allowance)
      this.getTradePendingReport(get(this.props, 'tpVehicle'))
  }

  render() {
    let { report, trade, className, rooftopName } = this.props,
      { payoff, allowance } = trade,
      { demand_index, tradein = {}, report_url, count } = report,
      { low, high } = tradein,
      tradeOk = !isEmpty(tradein) && allowance > 0 && count > 0,
      copy = {
        positive: {
          header: '🤩 We Want Your Car!',
          body: (
            <>
              we think your car could be worth{' '}
              <strong>{moneyShort(Math.floor(low))}</strong> to{' '}
              <strong>{moneyShort(Math.floor(high))}</strong> to us. We want to
              buy it!
            </>
          ),
        },
        negative: {
          header: "👋 Let's Talk!",
          body: (
            <>
              you're looking for about{' '}
              <strong>{moneyShort(allowance - high)}</strong> to{' '}
              <strong>{moneyShort(allowance - low)} more</strong> than the car
              is likely worth. But let's see what we can do.
            </>
          ),
        },
        unknown: {
          header: "🤷 We're Sorry!",
          body: (
            <>
              Were sorry, but we don't have enough information to give you an
              instant trade appraisal. We can still provide an appraisal but
              we'll need to see the car.
            </>
          ),
        },
      },
      tradeUnknown = (isEmpty(report) || !low) && trade.allowance > 0,
      reaction = tradeOk && high && allowance < high ? 'positive' : 'negative',
      demand = demand_index > 7 ? 'High' : demand_index > 3 ? 'Average' : 'Low'

    let copyReacion = tradeUnknown ? copy.unknown : copy[reaction]

    return (
      <div className={c('tp-report-inner', className)}>
        <div className="result">
          {!tradeOk ? (
            <h1>
              <span role="img" aria-label="appraisal">
                🚘
              </span>{' '}
              Get an Instant Trade Appraisal
            </h1>
          ) : (
            <h1>{copyReacion.header}</h1>
          )}
          {tradeOk && tradeUnknown && (
            <div className="report-content">{copyReacion.body}</div>
          )}
          {!tradeOk && (
            <div className="report-content">
              Tell us about your trade and we'll tell you if we can do it!
              Estimates are based on local market demand and current mileage are
              not guaranteed. A physical appraisal is required for an exact
              trade allowance.
            </div>
          )}
          {tradeOk && !tradeUnknown && (
            <div className="report-content">
              There are <strong>{count} cars </strong>like this one in the
              market and demand is <strong>{demand}</strong> for this vehicle,{' '}
              {copyReacion.body}
            </div>
          )}
          {tradeOk && (
            <div className="report-content">
              A net trade value of <strong>{money(allowance - payoff)}</strong>{' '}
              will be applied to your quote. Your actual trade value may change
              after a professional appraisal by {rooftopName}
            </div>
          )}
        </div>

        <div className="tp-report-footer">
          {report_url && (
            <div className="report-content">
              <a
                className="callout"
                href={report_url}
                target="_blank"
                rel="noopener noreferrer"
              >
                More Details about ths Estimate
              </a>
            </div>
          )}
          <span className="tp-logo-wrapper">
            Powered by <img src={tpLogo} alt="powered by TradePending" />
          </span>
        </div>
      </div>
    )
  }
}

function mapStateToProps(state, op) {
  let trade = getQuoteValue(
      state,
      op.vehicleId,
      op.quoteId,
      `trades[${op.tradeIndex}]`,
      {},
    ),
    { mileage, allowance } = trade,
    tpVehicle = get(trade, 'tradePending.vehicle', {}),
    report = get(trade, 'tradePending.report', {}),
    zipCode = getQuoteValue(state, op.vehicleId, op.quoteId, 'customerZipCode')

  return {
    ...op,
    trade,
    tpVehicle,
    report,
    zipCode,
    mileage,
    triggers: { mileage, zipCode, tpVehicle, allowance },
    cantDo: !zipCode || !mileage || isEmpty(tpVehicle),
    rooftopWebsite: getRooftopWebsite(state),
    rooftopName: getRooftopName(state),
  }
}

export default connect(
  mapStateToProps,
  { updateQuote },
)(TradePendingReport)
